import ParkingTrace from './parking-trace'
export default ParkingTrace
